module.exports = {
  ROOT_TYPE:     0,
  TEXT_TYPE:     1,
  TAG_TYPE:      2,
  CLASS_TYPE:    3,
  INSTANCE_TYPE: 4,
}



// WEBPACK FOOTER //
// ../node_modules/vqua/lib/constants/nodeTypes.js